import React, { useRef, useState } from 'react'
import { Button } from 'react-bootstrap'
import { FaCircle, FaMicrophone } from 'react-icons/fa'
import NewTopNavBar from './NewTopNavBar'
import axios from 'axios'
import { toast } from 'react-toastify'
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk"; // Import Speech SDK

const YoutubeVideoTranscript = () => {
    // const [selectedFile, setSelectedFile] = useState(null)
    const [youtubeUrl, setYoutubeUrl] = useState(null)
    const [apiResponse, setApiResponse] = useState()
    const [isDesable, setIsDesable] = useState(false)
    const [isCreateArticle, setIsCreateingArticle] = useState(false)
    const [articleRes, setArticleRes] = useState()
    const [isRecording, setIsRecording] = useState(false);
    const recognizerRef = useRef(null);
    const [transcription, setTranscription] = useState("");
    const [data, setData] = useState({
        scriptId: "",
        scriptName: "",
        message: "",
    });
    const startTranscription = async () => {
        setIsRecording(true);

        const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
            "4dF8iLZOx3vaaFtd9EzT2xnRFgWz8ouaEhyAB108zDQjxdlOuTqbJQQJ99AKACYeBjFXJ3w3AAAYACOGFfCZ",
            "eastus"
        );
        speechConfig.speechRecognitionLanguage = "en-US";

        const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
        const recognizer = new SpeechSDK.SpeechRecognizer(
            speechConfig,
            audioConfig
        );

        // Save the recognizer instance
        recognizerRef.current = recognizer;

        recognizer.recognizing = (s, e) => {
            console.log(`Recognizing: ${e.result.text}`);
        };

        recognizer.recognized = (s, e) => {
            if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
                const recognizedText = e.result.text.trim(); // Get the newly recognized text
                setTranscription((prev) => `${prev} ${recognizedText}`); // Update transcription state

                setData((prevData) => ({
                    ...prevData,
                    message: prevData.message
                        ? `${prevData.message} ${recognizedText}`
                        : recognizedText,
                }));

                console.log(`Recognized: ${recognizedText}`);
            } else if (e.result.reason === SpeechSDK.ResultReason.NoMatch) {
                console.log("No speech recognized.");
            }
        };

        recognizer.canceled = (s, e) => {
            console.error(`Canceled: ${e.errorDetails}`);
            recognizer.close();
            recognizerRef.current = null; // Clean up the recognizer reference
            setIsRecording(false);
        };

        recognizer.sessionStopped = (s, e) => {
            console.log("Session stopped.");
            recognizer.close();
            recognizerRef.current = null;
            setIsRecording(false);
        };

        recognizer.startContinuousRecognitionAsync();
    };
    const stopTranscription = () => {
        if (recognizerRef.current) {
            recognizerRef.current.stopContinuousRecognitionAsync(() => {
                console.log("Recognition stopped.");
                recognizerRef.current.close();
                recognizerRef.current = null;
            });
        }
        setIsRecording(false);
    };
    const config = {
        headers: {

            "Content-Type": "application/json",
        },
    };
    const handleFileChange = (e) => {
        // console.log(e.target.files[0])
        // setSelectedFile(e.target.files[0])
        setYoutubeUrl(e.target.value)
    }
    const handleSubmit = () => {
        if (!youtubeUrl) {
            toast.error("Please give youtube url.");
            return
        }
        // const maxSize = 25 * 1024 * 1024; // 25 MB in bytes
        // if (selectedFile.size > maxSize) {
        //     toast.error("File size must not exceed 25 MB.");
        //     setSelectedFile(null); // Clear the selected file
        //     return;
        // }

        // setIsDesable(true)
        // const formData = new FormData();
        // formData.append("file", selectedFile);
        const apiBody = {
            "url": youtubeUrl
        }

        function reteriveTranscript() {
            //   const videoId = new URLSearchParams(window.location.search).get("v");
            //   videoId = "jPF0oiWPF8w";
            const YT_INITIAL_PLAYER_RESPONSE_RE =
                /ytInitialPlayerResponse\s*=\s*({.+?})\s*;\s*(?:var\s+(?:meta|head)|<\/script|\n)/;
            //   let player = window.ytInitialPlayerResponse;

            let player = true;
            if (youtubeUrl.length > 5) {
                fetch(`${youtubeUrl}`)

                    // fetch(`youtubeUrl`, {
                    //     method: 'GET',
                    //     // mode: 'no-cors',
                    //     // headers: {
                    //     //     // Authorization: `Bearer: ${token}`,
                    //     //     'Content-Type': 'application/json',
                    //     // },
                    // })
                    .then(function (response) {
                        return response.text();
                    })
                    .then(function (body) {
                        console.log("body=", body)
                        const playerResponse = body.match(YT_INITIAL_PLAYER_RESPONSE_RE);
                        // console.log("playerResponse=", playerResponse);
                        if (!playerResponse) {
                            console.warn("Unable to parse playerResponse");
                            return;
                        }
                        player = JSON.parse(playerResponse[1]);
                        console.log("player=", player)
                        const metadata = {
                            // title: player.videoDetails.title,
                            // duration: player.videoDetails.lengthSeconds,
                            // author: player.videoDetails.author,
                            // views: player.videoDetails.viewCount,
                            title: player.videoDetails.title,
                            duration: player.videoDetails.lengthSeconds,
                            author: player.videoDetails.author,
                            views: player.videoDetails.viewCount,
                        };
                        // Get the tracks and sort them by priority
                        const tracks =
                            player.captions.playerCaptionsTracklistRenderer.captionTracks;
                        tracks.sort(compareTracks);

                        // Get the transcript
                        fetch(tracks[0].baseUrl + "&fmt=json3")
                            .then(function (response) {
                                return response.json();
                            })
                            .then(function (transcript) {
                                const result = { transcript: transcript, metadata: metadata };

                                const parsedTranscript = transcript.events
                                    // Remove invalid segments
                                    .filter(function (x) {
                                        return x.segs;
                                    })

                                    // Concatenate into single long string
                                    .map(function (x) {
                                        return x.segs
                                            .map(function (y) {
                                                return y.utf8;
                                            })
                                            .join(" ");
                                    })
                                    .join(" ")

                                    // Remove invalid characters
                                    .replace(/[\u200B-\u200D\uFEFF]/g, "")

                                    // Replace any whitespace with a single space
                                    .replace(/\s+/g, " ");

                                // Use 'result' here as needed
                                console.log("EXTRACTED_TRANSCRIPT", parsedTranscript);

                                setApiResponse(parsedTranscript)
                                // setData(...data, { message: res.data.transcript })
                                setData(prevData => ({
                                    ...prevData,
                                    message: parsedTranscript  // Updating scriptId
                                }));
                            });
                    });
            }
        }

        function compareTracks(track1, track2) {
            const langCode1 = track1.languageCode;
            const langCode2 = track2.languageCode;

            if (langCode1 === "en" && langCode2 !== "en") {
                return -1; // English comes first
            } else if (langCode1 !== "en" && langCode2 === "en") {
                return 1; // English comes first
            } else if (track1.kind !== "asr" && track2.kind === "asr") {
                return -1; // Non-ASR comes first
            } else if (track1.kind === "asr" && track2.kind !== "asr") {
                return 1; // Non-ASR comes first
            }

            return 0; // Preserve order if both have same priority
        }
        reteriveTranscript();

        // axios
        //     .post(`http://127.0.0.1:5000/get-transcript`, apiBody, config)
        //     .then((res) => {
        //         console.log(res.data);
        //         setApiResponse(res.data.transcript)
        //         // setData(...data, { message: res.data.transcript })
        //         setData(prevData => ({
        //             ...prevData,
        //             message: res.data.transcript  // Updating scriptId
        //         }));
        //         setIsDesable(false)
        //     }).catch((err) => {
        //         console.log(err)
        //         setIsDesable(false)
        //     })
    }
    const handleChange = (e) => {
        console.log("handle change");
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const handleCreateArticle = () => {
        setIsCreateingArticle(true)
        const ticketStr = { ticketStr: data.message, context: "LLM" }
        console.log(apiResponse.length)
        axios.post(`https://krstaging.camptratech.com/youtube-trascript-to-article/generate-article`, ticketStr, config).then((res) => {
            console.log("line44=", res.data)
            setArticleRes(res.data.description)

            setIsCreateingArticle(false)
        }).catch((err) => {
            setIsCreateingArticle(false)
            console.log(err)
        })
    }
    const goBackClick = () => {
        setArticleRes(null)
        setApiResponse(null)
        setData({
            scriptId: "",
            scriptName: "",
            message: "",
        })
    }
    return (
        <div>
            <div>
                <NewTopNavBar />
            </div>
            {articleRes ? <div className=''> <div className="pt-5 px-4" dangerouslySetInnerHTML={{ __html: articleRes ? articleRes : "" }} />
                <div className='text-center'>
                    <Button onClick={goBackClick}>Go Back</Button>
                </div>
            </div> :
                <div className='container pt-5'>

                    <div>
                        <div>
                            <h3 className='text-center pb-4'>Youtube Video Transcription</h3>
                        </div>
                        <div className='upload-users-section input-group align-items-center'>
                            <input placeholder='Enter the url' className='form-control ' type="url" name="" id="csvFile" onChange={handleFileChange} />
                            <div>
                                <Button
                                    disabled={isDesable}
                                    onClick={handleSubmit}>{isDesable ? "Generating..." : "Generate"}</Button>
                            </div>
                        </div>

                        <div>
                            {/* <textarea name="" id="" value={apiResponse}></textarea> */}
                            {/* <p className='pt-4'>{apiResponse ? apiResponse : ""}</p> */}
                            {/*  */}
                            {data.message.length > 0 ?
                                <div className="form-group pt-4 " style={{ position: "relative" }}>
                                    <textarea
                                        className="form-control textarea"
                                        placeholder="You can paste the message or use the microphone to generate the message as you create a scenario in Oracle"
                                        name="message"
                                        value={data.message}
                                        onChange={handleChange}
                                        style={{
                                            minHeight: "280px",
                                            background: "gainsboro",
                                            position: "relative",
                                            paddingRight: "40px", // Leave space for the mic icon
                                            paddingTop: "20px",
                                            paddingLeft: "20px",
                                        }}
                                    />
                                    {/* Mic Icon */}
                                    <div
                                        style={{
                                            position: "absolute",
                                            bottom: "10px",
                                            right: "15px",
                                            cursor: "pointer",
                                            display: "none"
                                        }}
                                        onClick={
                                            isRecording ? stopTranscription : startTranscription
                                        }
                                    >
                                        <FaMicrophone
                                            className='d-none'
                                            size={24}
                                            color={isRecording ? "red" : "black"} // Change mic color when active
                                            title={
                                                isRecording ? "Stop Listening" : "Start Listening"
                                            }
                                        />
                                    </div>
                                    {/* Recording Indicator */}
                                    {isRecording && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "8px",
                                                right: "15px",
                                                color: "red",
                                                fontSize: "12px",
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <FaCircle size={8} style={{ marginRight: "5px" }} />
                                            Recording...
                                        </div>
                                    )}
                                </div>
                                : ""}
                            {/*  */}
                            <div className='text-end'>
                                {apiResponse ? <Button disabled={isCreateArticle} onClick={handleCreateArticle}>{isCreateArticle ? "Creating Article" : "Create Article"}</Button> : ""}
                            </div>
                        </div>
                    </div>


                </div>
            }


        </div>
    )
}

export default YoutubeVideoTranscript